import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "text-sm sm:flex justify-content-between align-items-start gutter-y-s2" }
const _hoisted_3 = { class: "flex flex-wrap sm:w-auto align-items-center" }
const _hoisted_4 = { class: "sm:w-full" }
const _hoisted_5 = { class: "flex align-items-center ml-s-auto sm:ml-s2 sm:flex-order-3" }
const _hoisted_6 = { class: "w-full sm:w-auto" }
const _hoisted_7 = { class: "caption" }
const _hoisted_8 = { class: "w-auto sm:flex sm:flex-column sm:align-items-end" }
const _hoisted_9 = { class: "flex align-items-center white-space-nowrap" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "text-sm" }

import BigNumber from 'bignumber.js';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { printBalanceWithCurrency, printUSDBalance } from '@/utils/format';
import { USD_TOKEN } from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/common/constants/USD_TOKEN';
import Icon from '@/components/icon/Icon.vue';
import Caption from '@/components/Caption.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputPanelInfoData',
  props: {
    balance: null,
    farmStaked: null,
    balanceInCardano: null,
    balanceInMilkomeda: null,
    showBalanceTooltip: { type: Boolean },
    currency: null,
    balanceError: { type: Boolean },
    tooltip: null
  },
  emits: ["clickUnstake"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'clickUnstake'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  balance: BigNumber;
  farmStaked: BigNumber;
  balanceInCardano: BigNumber;
  balanceInMilkomeda: BigNumber;
  showBalanceTooltip: boolean;
  currency: string;
  balanceError: boolean;
  tooltip?: string;
}

const BALANCE_DECIMALS_FOR_TOOLTIP = 2;

const { t } = useI18n();





const isUSDValue = computed(() => props.currency === USD_TOKEN.symbol);
const isFarmStaked = computed(() => !props.farmStaked.eq(0));
const balanceLPInCardanoFixed = computed(() =>
  props.balanceInCardano.toFixed(BALANCE_DECIMALS_FOR_TOOLTIP, BigNumber.ROUND_DOWN),
);
const balanceLPInMilkomedaFixed = computed(() =>
  props.balanceInMilkomeda.toFixed(BALANCE_DECIMALS_FOR_TOOLTIP, BigNumber.ROUND_DOWN),
);

const getFormatValue = value => {
  if (isUSDValue.value) {
    return printUSDBalance(value);
  }

  return printBalanceWithCurrency(value, props.currency);
};

const availableBalance = computed(() => {
  return getFormatValue(props.balance);
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Caption, {
            caption: _unref(t)('portfolio.withdraw.stakedInTheFarm'),
            tooltip: _unref(t)('portfolio.tooltip.stakedInTheFarm')
          }, null, 8, ["caption", "tooltip"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_unref(isFarmStaked))
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "text-sm button-text",
                label: _unref(t)('unstake'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('clickUnstake')))
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(getFormatValue(__props.farmStaked)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (__props.balanceError)
            ? (_openBlock(), _createBlock(Icon, {
                key: 0,
                class: "text-danger mr-s1 align-self-center",
                name: "danger",
                size: "16"
              }))
            : _createCommentVNode("", true),
          (_unref(isUSDValue))
            ? (_openBlock(), _createBlock(Caption, {
                key: 1,
                caption: _unref(t)('availableBalance'),
                "is-error": __props.balanceError,
                withFormattedText: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('portfolio.tooltip.availableUSDBalance')) + " ", 1),
                  _hoisted_10,
                  _createTextVNode(" " + _toDisplayString(_unref(t)('portfolio.tooltip.switchToLPForMoreAccurance')), 1)
                ]),
                _: 1
              }, 8, ["caption", "is-error"]))
            : (_openBlock(), _createBlock(Caption, {
                key: 2,
                caption: _unref(t)('availableBalance'),
                tooltip: _unref(t)('portfolio.tooltip.availableLPBalance'),
                "is-error": __props.balanceError
              }, _createSlots({ _: 2 }, [
                (__props.showBalanceTooltip)
                  ? {
                      name: "tooltip",
                      fn: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(_unref(t)('wrappedContract.inChain', { chain: 'Cardano' })) + ": ", 1),
                          _createElementVNode("span", null, _toDisplayString(_unref(balanceLPInCardanoFixed)), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(_unref(t)('wrappedContract.inChain', { chain: 'Milkomeda' })) + ": ", 1),
                          _createElementVNode("span", null, _toDisplayString(_unref(balanceLPInMilkomedaFixed)), 1)
                        ])
                      ])
                    }
                  : undefined
              ]), 1032, ["caption", "tooltip", "is-error"]))
        ]),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(availableBalance)), 1)
      ])
    ])
  ]))
}
}

})